import { t } from "@/i18n-js/instance";
import { BuilderUI, useBuilderStore } from "@circle-react-shared/BuilderUI";
import { BlockRenderer } from "@circle-react-shared/BuilderUI/Renderer/BlockRenderer";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export const FullscreenPreview = () => {
  const {
    blocks,
    isFullscreenPreview,
    exitFullscreenPreview,
    getBlockRenderers,
  } = useBuilderStore(state => ({
    blocks: state.getBlocks(),
    isFullscreenPreview: state.isFullscreenPreview,
    exitFullscreenPreview: state.exitFullscreenPreview,
    getBlockRenderers: state.getBlockRenderers,
  }));

  const components = getBlockRenderers();

  if (!isFullscreenPreview) {
    return null;
  }

  return (
    <div className="bg-primary fixed left-0 top-0 isolate z-50 size-full">
      <BuilderUI.TailwindFrame>
        <BuilderUI.ThemeManager>
          <BlockRenderer block={blocks} components={components} />
        </BuilderUI.ThemeManager>
      </BuilderUI.TailwindFrame>
      <IconButton
        name="20-close"
        onClick={exitFullscreenPreview}
        iconSize={20}
        buttonSize={28}
        className="absolute right-1 top-[18px] z-50"
        title={t("builder_ui.canvas.exit_fullscreen")}
        ariaLabel={t("builder_ui.canvas.exit_fullscreen")}
      />
    </div>
  );
};
